/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_stat_wpm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WPM`)
};

const es_typing_stat_wpm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WPM`)
};

const de_typing_stat_wpm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WPM`)
};

const nl_typing_stat_wpm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WPM`)
};

const fr_typing_stat_wpm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WPM`)
};

const it_typing_stat_wpm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WPM`)
};

const pt_br2_typing_stat_wpm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WPM`)
};

const pt_typing_stat_wpm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WPM`)
};

const ja_typing_stat_wpm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WPM`)
};

const zh_typing_stat_wpm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WPM`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_stat_wpm = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_stat_wpm(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_stat_wpm", locale)
	if (locale === "en") return en_typing_stat_wpm(inputs)
	if (locale === "es") return es_typing_stat_wpm(inputs)
	if (locale === "de") return de_typing_stat_wpm(inputs)
	if (locale === "nl") return nl_typing_stat_wpm(inputs)
	if (locale === "fr") return fr_typing_stat_wpm(inputs)
	if (locale === "it") return it_typing_stat_wpm(inputs)
	if (locale === "pt-BR") return pt_br2_typing_stat_wpm(inputs)
	if (locale === "pt") return pt_typing_stat_wpm(inputs)
	if (locale === "ja") return ja_typing_stat_wpm(inputs)
	return zh_typing_stat_wpm(inputs)
};